import styled from 'styled-components';

import { IconComponent } from './types';

// Pass direction ['up', 'down', 'left', 'right'] to rotate.
const ChevronIcon = styled((props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="11"
      fill="none"
      viewBox="0 0 9 9"
      {...props}
    >
      <path
        d="M7.455 2.20508L4.5 5.16008L1.545 2.20508L0.75 3.00008L4.5 6.75008L8.25 3.00008L7.455 2.20508Z"
        fill="currentColor"
      />
    </svg>
  );
})`
  display: block;
  ${({ direction }) =>
    direction === 'up'
      ? 'transform: rotate(180deg);'
      : direction === 'right'
      ? 'transform: rotate(-90deg);'
      : direction === 'left'
      ? 'transform: rotate(90deg);'
      : ''}
` as IconComponent<{
  direction: 'up' | 'down' | 'left' | 'right';
}>;

export default ChevronIcon;
